/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Openrequestslabel2Inputs */

const en_openrequestslabel2 = /** @type {(inputs: Openrequestslabel2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open requests: ${i?.count}`)
};

const de_openrequestslabel2 = /** @type {(inputs: Openrequestslabel2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Offene Anfragen: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Open requests: {count}" |
*
* @param {Openrequestslabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const openrequestslabel2 = /** @type {((inputs: Openrequestslabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openrequestslabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openrequestslabel2(inputs)
	return de_openrequestslabel2(inputs)
});
export { openrequestslabel2 as "openRequestsLabel" }